import * as yup from 'yup';

export const SHOPIFY_SUBSCRIPTION_DISCOUNT_EMAIL_REQUIRED = 'Email is required';
export const SHOPIFY_SUBSCRIPTION_DISCOUNT_EMAIL_INVALID =
	'Please enter a valid email address';
export const SHOPIFY_SUBSCRIPTION_DISCOUNT_PLAN_NAME_REQUIRED =
	'Plan name is required';
export const SHOPIFY_SUBSCRIPTION_DISCOUNT_PERCENTAGE_REQUIRED =
	'Percentage is required';
export const SHOPIFY_SUBSCRIPTION_DISCOUNT_PERCENTAGE_MIN =
	'Percentage must be at least 0';
export const SHOPIFY_SUBSCRIPTION_DISCOUNT_PERCENTAGE_MAX =
	'Percentage must be at most 100';
export const SHOPIFY_SUBSCRIPTION_DISCOUNT_DURATION_REQUIRED =
	'Duration in months is required';
export const SHOPIFY_SUBSCRIPTION_DISCOUNT_DURATION_MIN =
	'Duration must be at least 1 month';
export const SHOPIFY_SUBSCRIPTION_DISCOUNT_DURATION_MAX =
	'Duration must be at most 12 months';

export const shopifySubscriptionDiscountSchema = yup.object({
	email: yup
		.string()
		.email(SHOPIFY_SUBSCRIPTION_DISCOUNT_EMAIL_INVALID)
		.required(SHOPIFY_SUBSCRIPTION_DISCOUNT_EMAIL_REQUIRED),
	planName: yup
		.string()
		.required(SHOPIFY_SUBSCRIPTION_DISCOUNT_PLAN_NAME_REQUIRED),
	percentage: yup
		.number()
		.min(0, SHOPIFY_SUBSCRIPTION_DISCOUNT_PERCENTAGE_MIN)
		.max(100, SHOPIFY_SUBSCRIPTION_DISCOUNT_PERCENTAGE_MAX)
		.required(SHOPIFY_SUBSCRIPTION_DISCOUNT_PERCENTAGE_REQUIRED),
	durationMonths: yup
		.number()
		.min(1, SHOPIFY_SUBSCRIPTION_DISCOUNT_DURATION_MIN)
		.max(12, SHOPIFY_SUBSCRIPTION_DISCOUNT_DURATION_MAX)
		.required(SHOPIFY_SUBSCRIPTION_DISCOUNT_DURATION_REQUIRED),
});
